var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
export var ActionEnum;
(function (ActionEnum) {
    ActionEnum["ActionAffiliateLevelUpdate"] = "ACTION_AFFILIATE_LEVEL_UPDATE";
    ActionEnum["ActionAffiliateReferralPayment"] = "ACTION_AFFILIATE_REFERRAL_PAYMENT";
    ActionEnum["ActionAffiliateRequisitesAccepted"] = "ACTION_AFFILIATE_REQUISITES_ACCEPTED";
    ActionEnum["ActionAffiliateRequisitesDeclined"] = "ACTION_AFFILIATE_REQUISITES_DECLINED";
    ActionEnum["ActionAffiliateWithdrawAccepted"] = "ACTION_AFFILIATE_WITHDRAW_ACCEPTED";
    ActionEnum["ActionAffiliateWithdrawDeclined"] = "ACTION_AFFILIATE_WITHDRAW_DECLINED";
    ActionEnum["ActionBillingSchoolRequisitesAccepted"] = "ACTION_BILLING_SCHOOL_REQUISITES_ACCEPTED";
    ActionEnum["ActionBillingSchoolRequisitesDeclined"] = "ACTION_BILLING_SCHOOL_REQUISITES_DECLINED";
    ActionEnum["ActionBillingStudentPaidCourse"] = "ACTION_BILLING_STUDENT_PAID_COURSE";
    ActionEnum["ActionBillingWithdrawAccepted"] = "ACTION_BILLING_WITHDRAW_ACCEPTED";
    ActionEnum["ActionBillingWithdrawDecline"] = "ACTION_BILLING_WITHDRAW_DECLINE";
    ActionEnum["ActionChatStudentWaitAnswer_24Hour"] = "ACTION_CHAT_STUDENT_WAIT_ANSWER_24_HOUR";
    ActionEnum["ActionCourseAccessGroupStudentLimitOver"] = "ACTION_COURSE_ACCESS_GROUP_STUDENT_LIMIT_OVER";
    ActionEnum["ActionCourseAccessStudentAccessEnd"] = "ACTION_COURSE_ACCESS_STUDENT_ACCESS_END";
    ActionEnum["ActionCourseAccessStudentAccessEnd_3Days"] = "ACTION_COURSE_ACCESS_STUDENT_ACCESS_END_3_DAYS";
    ActionEnum["ActionCourseAccessStudentExpel"] = "ACTION_COURSE_ACCESS_STUDENT_EXPEL";
    ActionEnum["ActionCourseAccessStudentInvite"] = "ACTION_COURSE_ACCESS_STUDENT_INVITE";
    ActionEnum["ActionCourseAccessStudentInviteAndRegister"] = "ACTION_COURSE_ACCESS_STUDENT_INVITE_AND_REGISTER";
    ActionEnum["ActionCourseAccessStudentNewLesson"] = "ACTION_COURSE_ACCESS_STUDENT_NEW_LESSON";
    ActionEnum["ActionCourseAccessStudentNewStep"] = "ACTION_COURSE_ACCESS_STUDENT_NEW_STEP";
    ActionEnum["ActionCoursePublishedNewLesson"] = "ACTION_COURSE_PUBLISHED_NEW_LESSON";
    ActionEnum["ActionCourseStudentFinishCourse"] = "ACTION_COURSE_STUDENT_FINISH_COURSE";
    ActionEnum["ActionCourseUpcomingWebinarStudent"] = "ACTION_COURSE_UPCOMING_WEBINAR_STUDENT";
    ActionEnum["ActionCourseUpcomingWebinarTeacher"] = "ACTION_COURSE_UPCOMING_WEBINAR_TEACHER";
    ActionEnum["ActionCourseWebinarStartStudent"] = "ACTION_COURSE_WEBINAR_START_STUDENT";
    ActionEnum["ActionDeadlineExpired"] = "ACTION_DEADLINE_EXPIRED";
    ActionEnum["ActionDeadlineUpcoming_1Day"] = "ACTION_DEADLINE_UPCOMING_1_DAY";
    ActionEnum["ActionDeadlineUpcoming_3Days"] = "ACTION_DEADLINE_UPCOMING_3_DAYS";
    ActionEnum["ActionHomeworksStudentsSentCron"] = "ACTION_HOMEWORKS_STUDENTS_SENT_CRON";
    ActionEnum["ActionHomeworksTeacherSentCron"] = "ACTION_HOMEWORKS_TEACHER_SENT_CRON";
    ActionEnum["ActionHomeworkStudentSent"] = "ACTION_HOMEWORK_STUDENT_SENT";
    ActionEnum["ActionHomeworkTeacherSent"] = "ACTION_HOMEWORK_TEACHER_SENT";
    ActionEnum["ActionSchoolFileRemoved"] = "ACTION_SCHOOL_FILE_REMOVED";
    ActionEnum["ActionSchoolFileRemoveAfter_3Days"] = "ACTION_SCHOOL_FILE_REMOVE_AFTER_3_DAYS";
    ActionEnum["ActionSchoolFileRemoveAfter_14Days"] = "ACTION_SCHOOL_FILE_REMOVE_AFTER_14_DAYS";
    ActionEnum["ActionSchoolSettingsDiscountExpired"] = "ACTION_SCHOOL_SETTINGS_DISCOUNT_EXPIRED";
    ActionEnum["ActionStudentExportStudentList"] = "ACTION_STUDENT_EXPORT_STUDENT_LIST";
    ActionEnum["ActionStudentExportStudentProgress"] = "ACTION_STUDENT_EXPORT_STUDENT_PROGRESS";
    ActionEnum["ActionTariffFeatureLimitExceeded"] = "ACTION_TARIFF_FEATURE_LIMIT_EXCEEDED";
    ActionEnum["ActionTariffSubscriptionExpirationIn_1Day"] = "ACTION_TARIFF_SUBSCRIPTION_EXPIRATION_IN_1_DAY";
    ActionEnum["ActionTariffSubscriptionExpirationIn_3Days"] = "ACTION_TARIFF_SUBSCRIPTION_EXPIRATION_IN_3_DAYS";
    ActionEnum["ActionTariffSubscriptionExpirationIn_7Days"] = "ACTION_TARIFF_SUBSCRIPTION_EXPIRATION_IN_7_DAYS";
    ActionEnum["ActionTariffSubscriptionExpired"] = "ACTION_TARIFF_SUBSCRIPTION_EXPIRED";
    ActionEnum["ActionTariffSubscriptionRecurrentPaymentFailure"] = "ACTION_TARIFF_SUBSCRIPTION_RECURRENT_PAYMENT_FAILURE";
    ActionEnum["ActionWebinarUpcomingStreamSpeaker"] = "ACTION_WEBINAR_UPCOMING_STREAM_SPEAKER";
    ActionEnum["ActionWebinarUpcomingStreamStarted"] = "ACTION_WEBINAR_UPCOMING_STREAM_STARTED";
    ActionEnum["ActionWebinarUpcomingStreamStudent"] = "ACTION_WEBINAR_UPCOMING_STREAM_STUDENT";
    ActionEnum["ActionWebinarUpcomingStreamStudentInvite"] = "ACTION_WEBINAR_UPCOMING_STREAM_STUDENT_INVITE";
})(ActionEnum || (ActionEnum = {}));
export var BillingCycleEnum;
(function (BillingCycleEnum) {
    BillingCycleEnum["Monthly"] = "monthly";
    BillingCycleEnum["Yearly"] = "yearly";
})(BillingCycleEnum || (BillingCycleEnum = {}));
export var CardsViewMode;
(function (CardsViewMode) {
    CardsViewMode["Catalog"] = "catalog";
    CardsViewMode["Library"] = "library";
})(CardsViewMode || (CardsViewMode = {}));
export var ClientEnum;
(function (ClientEnum) {
    ClientEnum["Browser"] = "BROWSER";
    ClientEnum["Email"] = "EMAIL";
    ClientEnum["Mobile"] = "MOBILE";
    ClientEnum["Platform"] = "PLATFORM";
    ClientEnum["Telegram"] = "TELEGRAM";
})(ClientEnum || (ClientEnum = {}));
export var CompletedEnum;
(function (CompletedEnum) {
    CompletedEnum["Completed"] = "completed";
    CompletedEnum["Uncompleted"] = "uncompleted";
})(CompletedEnum || (CompletedEnum = {}));
export var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["Rub"] = "RUB";
})(CurrencyEnum || (CurrencyEnum = {}));
export var DisplayRecordType;
(function (DisplayRecordType) {
    DisplayRecordType["ExternalLink"] = "externalLink";
    DisplayRecordType["File"] = "file";
    DisplayRecordType["Internal"] = "internal";
})(DisplayRecordType || (DisplayRecordType = {}));
export var FeatureTypeEnum;
(function (FeatureTypeEnum) {
    FeatureTypeEnum["Blocking"] = "blocking";
    FeatureTypeEnum["Limit"] = "limit";
})(FeatureTypeEnum || (FeatureTypeEnum = {}));
export var NotificationGroupEnum;
(function (NotificationGroupEnum) {
    NotificationGroupEnum["AffiliateUpdates"] = "AFFILIATE_UPDATES";
    NotificationGroupEnum["Billing"] = "BILLING";
    NotificationGroupEnum["Chat"] = "CHAT";
    NotificationGroupEnum["Courses"] = "COURSES";
    NotificationGroupEnum["CourseStudentFinished"] = "COURSE_STUDENT_FINISHED";
    NotificationGroupEnum["Deadlines"] = "DEADLINES";
    NotificationGroupEnum["Export"] = "EXPORT";
    NotificationGroupEnum["GroupStudentLimitOver"] = "GROUP_STUDENT_LIMIT_OVER";
    NotificationGroupEnum["Homeworks"] = "HOMEWORKS";
    NotificationGroupEnum["Invitations"] = "INVITATIONS";
    NotificationGroupEnum["Registration"] = "REGISTRATION";
    NotificationGroupEnum["SchoolSettings"] = "SCHOOL_SETTINGS";
    NotificationGroupEnum["Subscription"] = "SUBSCRIPTION";
    NotificationGroupEnum["Tariffs"] = "TARIFFS";
    NotificationGroupEnum["Webinars"] = "WEBINARS";
    NotificationGroupEnum["Withdrawal"] = "WITHDRAWAL";
})(NotificationGroupEnum || (NotificationGroupEnum = {}));
export var NotificationSoundEnum;
(function (NotificationSoundEnum) {
    NotificationSoundEnum["Bloop"] = "BLOOP";
    NotificationSoundEnum["Todo"] = "TODO";
    NotificationSoundEnum["Trum"] = "TRUM";
    NotificationSoundEnum["Uwa"] = "UWA";
    NotificationSoundEnum["Voop"] = "VOOP";
    NotificationSoundEnum["Woosh"] = "WOOSH";
})(NotificationSoundEnum || (NotificationSoundEnum = {}));
export var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["Cancelled"] = "CANCELLED";
    PaymentStatusEnum["Expired"] = "EXPIRED";
    PaymentStatusEnum["Failed"] = "FAILED";
    PaymentStatusEnum["Pending"] = "PENDING";
    PaymentStatusEnum["Successful"] = "SUCCESSFUL";
})(PaymentStatusEnum || (PaymentStatusEnum = {}));
export var RegistrationType;
(function (RegistrationType) {
    RegistrationType["ByInvitation"] = "byInvitation";
    RegistrationType["ByLanding"] = "byLanding";
})(RegistrationType || (RegistrationType = {}));
export var RoleEnum;
(function (RoleEnum) {
    RoleEnum["Student"] = "student";
    RoleEnum["Teacher"] = "teacher";
})(RoleEnum || (RoleEnum = {}));
export var SortEnum;
(function (SortEnum) {
    SortEnum["Asc"] = "ASC";
    SortEnum["Desc"] = "DESC";
})(SortEnum || (SortEnum = {}));
export var StatisticRecordType;
(function (StatisticRecordType) {
    StatisticRecordType["Attended"] = "ATTENDED";
    StatisticRecordType["Invited"] = "INVITED";
    StatisticRecordType["Registered"] = "REGISTERED";
    StatisticRecordType["Replayed"] = "REPLAYED";
})(StatisticRecordType || (StatisticRecordType = {}));
export var StreamRateAction;
(function (StreamRateAction) {
    StreamRateAction["Dislike"] = "DISLIKE";
    StreamRateAction["Like"] = "LIKE";
    StreamRateAction["RemoveDislike"] = "REMOVE_DISLIKE";
    StreamRateAction["RemoveLike"] = "REMOVE_LIKE";
})(StreamRateAction || (StreamRateAction = {}));
export var StreamType;
(function (StreamType) {
    StreamType["External"] = "external";
    StreamType["Internal"] = "internal";
})(StreamType || (StreamType = {}));
export var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    SubscriptionStatusEnum["Active"] = "active";
    SubscriptionStatusEnum["Canceled"] = "canceled";
    SubscriptionStatusEnum["Expired"] = "expired";
    SubscriptionStatusEnum["Pending"] = "pending";
    SubscriptionStatusEnum["Trial"] = "trial";
})(SubscriptionStatusEnum || (SubscriptionStatusEnum = {}));
export var UserRatingStatus;
(function (UserRatingStatus) {
    UserRatingStatus["Disliked"] = "DISLIKED";
    UserRatingStatus["Liked"] = "LIKED";
    UserRatingStatus["None"] = "NONE";
})(UserRatingStatus || (UserRatingStatus = {}));
export var VisitingStatusEnum;
(function (VisitingStatusEnum) {
    VisitingStatusEnum["Record"] = "record";
    VisitingStatusEnum["Registration"] = "registration";
    VisitingStatusEnum["Visit"] = "visit";
})(VisitingStatusEnum || (VisitingStatusEnum = {}));
export var WebinarType;
(function (WebinarType) {
    WebinarType["External"] = "external";
    WebinarType["Internal"] = "internal";
})(WebinarType || (WebinarType = {}));
export var WebinarVisibility;
(function (WebinarVisibility) {
    WebinarVisibility["Draft"] = "draft";
    WebinarVisibility["Private"] = "private";
    WebinarVisibility["Public"] = "public";
})(WebinarVisibility || (WebinarVisibility = {}));
export var DocumentPublishStatusFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment documentPublishStatus on DocumentOutput {\n  isPublished\n  updatedAt\n}\n    "], ["\n    fragment documentPublishStatus on DocumentOutput {\n  isPublished\n  updatedAt\n}\n    "])));
export var UpdatePageFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment updatePage on PageOutput {\n  id\n  order\n  hasUnpublishedChanges\n  updatedAt\n  title\n}\n    "], ["\n    fragment updatePage on PageOutput {\n  id\n  order\n  hasUnpublishedChanges\n  updatedAt\n  title\n}\n    "])));
export var UpdatePagesFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment updatePages on DocumentOutput {\n  pages {\n    id\n    order\n    hasUnpublishedChanges\n    updatedAt\n    createdAt\n    title\n  }\n}\n    "], ["\n    fragment updatePages on DocumentOutput {\n  pages {\n    id\n    order\n    hasUnpublishedChanges\n    updatedAt\n    createdAt\n    title\n  }\n}\n    "])));
export var UpdateNotificationViewedStatusFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    fragment UpdateNotificationViewedStatus on UserNotificationOutput {\n  viewed\n}\n    "], ["\n    fragment UpdateNotificationViewedStatus on UserNotificationOutput {\n  viewed\n}\n    "])));
export var StudentNoteFragmentDoc = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    fragment StudentNote on StudentNoteOutput {\n  id\n  __typename\n  text\n  studentId\n  createdBy\n  createdAt\n  updatedAt\n  schoolId\n  attachments {\n    id\n    url\n    mimeType\n    size\n    name\n    __typename\n  }\n}\n    "], ["\n    fragment StudentNote on StudentNoteOutput {\n  id\n  __typename\n  text\n  studentId\n  createdBy\n  createdAt\n  updatedAt\n  schoolId\n  attachments {\n    id\n    url\n    mimeType\n    size\n    name\n    __typename\n  }\n}\n    "])));
export var CreateNewStreamFragmentDoc = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    fragment CreateNewStream on StreamOutput {\n  id\n  title\n  date\n  duration\n  __typename\n}\n    "], ["\n    fragment CreateNewStream on StreamOutput {\n  id\n  title\n  date\n  duration\n  __typename\n}\n    "])));
export var RateStreamFragmentDoc = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    fragment rateStream on SocialActivityOutput {\n  dislikesCount\n  likesCount\n  userRating\n}\n    "], ["\n    fragment rateStream on SocialActivityOutput {\n  dislikesCount\n  likesCount\n  userRating\n}\n    "])));
export var ShareStreamFragmentDoc = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    fragment shareStream on SocialActivityOutput {\n  hasShared\n  sharesCount\n}\n    "], ["\n    fragment shareStream on SocialActivityOutput {\n  hasShared\n  sharesCount\n}\n    "])));
export var UpdateStreamFragmentDoc = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    fragment updateStream on StreamOutput {\n  coverFileId\n  cover {\n    url\n  }\n  date\n  duration\n  id\n  recordUrl\n  streamType\n  title\n  externalStreamUrl\n  hasRecordUrl\n  hasRecord\n  countRegistered\n  countViewed\n  isRegistered\n  isSpeaker\n  autoRecord\n  savedRecordFileId\n  isAllowedToJoin\n  isLive\n  useNotifications\n  displayRecordType\n  registrationType\n  uploadedRecordFileId\n  uploadedRecord {\n    url\n    name\n  }\n}\n    "], ["\n    fragment updateStream on StreamOutput {\n  coverFileId\n  cover {\n    url\n  }\n  date\n  duration\n  id\n  recordUrl\n  streamType\n  title\n  externalStreamUrl\n  hasRecordUrl\n  hasRecord\n  countRegistered\n  countViewed\n  isRegistered\n  isSpeaker\n  autoRecord\n  savedRecordFileId\n  isAllowedToJoin\n  isLive\n  useNotifications\n  displayRecordType\n  registrationType\n  uploadedRecordFileId\n  uploadedRecord {\n    url\n    name\n  }\n}\n    "])));
export var UpdateStreamAfterUpdateWebinarFragmentDoc = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    fragment updateStreamAfterUpdateWebinar on StreamOutput {\n  webinarTitle\n  webinarDescription\n  isShowShareButton\n  registrationType\n}\n    "], ["\n    fragment updateStreamAfterUpdateWebinar on StreamOutput {\n  webinarTitle\n  webinarDescription\n  isShowShareButton\n  registrationType\n}\n    "])));
export var UpdateWebinarFragmentDoc = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    fragment updateWebinar on WebinarOutput {\n  countRegistered\n  countViewed\n  coverFileId\n  cover {\n    url\n  }\n  description\n  externalLandingUrl\n  id\n  integrationCode\n  maxStudentCapacity\n  registrationForEntry\n  registrationForView\n  registrationType\n  title\n  useDefaultLanding\n  visibility\n  isPhoneRequiredOnRegistration\n  isShowShareButton\n}\n    "], ["\n    fragment updateWebinar on WebinarOutput {\n  countRegistered\n  countViewed\n  coverFileId\n  cover {\n    url\n  }\n  description\n  externalLandingUrl\n  id\n  integrationCode\n  maxStudentCapacity\n  registrationForEntry\n  registrationForView\n  registrationType\n  title\n  useDefaultLanding\n  visibility\n  isPhoneRequiredOnRegistration\n  isShowShareButton\n}\n    "])));
export var GetAnalyticsDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    query GetAnalytics($courseId: String, $groupId: String) {\n  analytics(courseId: $courseId, groupId: $groupId) {\n    activeStudents {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    avgCourseProgress {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    avgScore {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    newStudents {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n  }\n}\n    "], ["\n    query GetAnalytics($courseId: String, $groupId: String) {\n  analytics(courseId: $courseId, groupId: $groupId) {\n    activeStudents {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    avgCourseProgress {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    avgScore {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n    newStudents {\n      currentPeriodTotal\n      previousPeriodTotal\n      states {\n        value\n        date\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetAnalyticsQuery__
 *
 * To run a query within a Vue component, call `useGetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAnalyticsQuery({
 *   courseId: // value for 'courseId'
 *   groupId: // value for 'groupId'
 * });
 */
export function useGetAnalyticsQuery(variables, options) {
    if (variables === void 0) { variables = {}; }
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetAnalyticsDocument, variables, options);
}
export function useGetAnalyticsLazyQuery(variables, options) {
    if (variables === void 0) { variables = {}; }
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetAnalyticsDocument, variables, options);
}
export var AddPageDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    mutation AddPage($docId: ID!) {\n  addPage(docId: $docId) {\n    hasUnpublishedChanges\n    id\n    order\n    updatedAt\n    createdAt\n    title\n  }\n}\n    "], ["\n    mutation AddPage($docId: ID!) {\n  addPage(docId: $docId) {\n    hasUnpublishedChanges\n    id\n    order\n    updatedAt\n    createdAt\n    title\n  }\n}\n    "])));
/**
 * __useAddPageMutation__
 *
 * To run a mutation, you first call `useAddPageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPageMutation({
 *   variables: {
 *     docId: // value for 'docId'
 *   },
 * });
 */
export function useAddPageMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(AddPageDocument, options);
}
export var DeletePageDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    mutation DeletePage($pageId: ID!) {\n  deletePage(pageId: $pageId) {\n    success\n  }\n}\n    "], ["\n    mutation DeletePage($pageId: ID!) {\n  deletePage(pageId: $pageId) {\n    success\n  }\n}\n    "])));
/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePageMutation({
 *   variables: {
 *     pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(DeletePageDocument, options);
}
export var PublishDocumentDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    mutation PublishDocument($docId: ID!) {\n  publishDocument(docId: $docId) {\n    success\n  }\n}\n    "], ["\n    mutation PublishDocument($docId: ID!) {\n  publishDocument(docId: $docId) {\n    success\n  }\n}\n    "])));
/**
 * __usePublishDocumentMutation__
 *
 * To run a mutation, you first call `usePublishDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishDocumentMutation({
 *   variables: {
 *     docId: // value for 'docId'
 *   },
 * });
 */
export function usePublishDocumentMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(PublishDocumentDocument, options);
}
export var UpdatePageDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    mutation UpdatePage($pageId: ID!, $updatePageInput: UpdatePageTitleInput!) {\n  updatePage(pageId: $pageId, input: $updatePageInput) {\n    id\n    hasUnpublishedChanges\n    order\n    updatedAt\n    title\n  }\n}\n    "], ["\n    mutation UpdatePage($pageId: ID!, $updatePageInput: UpdatePageTitleInput!) {\n  updatePage(pageId: $pageId, input: $updatePageInput) {\n    id\n    hasUnpublishedChanges\n    order\n    updatedAt\n    title\n  }\n}\n    "])));
/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePageMutation({
 *   variables: {
 *     pageId: // value for 'pageId'
 *     updatePageInput: // value for 'updatePageInput'
 *   },
 * });
 */
export function useUpdatePageMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdatePageDocument, options);
}
export var UpdatePagesDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    mutation UpdatePages($docId: ID!, $updatePagesInput: UpdatePagesInput!) {\n  updateDocumentPages(docId: $docId, updatePagesInput: $updatePagesInput) {\n    success\n  }\n}\n    "], ["\n    mutation UpdatePages($docId: ID!, $updatePagesInput: UpdatePagesInput!) {\n  updateDocumentPages(docId: $docId, updatePagesInput: $updatePagesInput) {\n    success\n  }\n}\n    "])));
/**
 * __useUpdatePagesMutation__
 *
 * To run a mutation, you first call `useUpdatePagesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePagesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePagesMutation({
 *   variables: {
 *     docId: // value for 'docId'
 *     updatePagesInput: // value for 'updatePagesInput'
 *   },
 * });
 */
export function useUpdatePagesMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdatePagesDocument, options);
}
export var GetDocumentDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    query GetDocument($docId: ID!) {\n  document(docId: $docId) {\n    id\n    pages {\n      id\n      content\n      title\n    }\n  }\n}\n    "], ["\n    query GetDocument($docId: ID!) {\n  document(docId: $docId) {\n    id\n    pages {\n      id\n      content\n      title\n    }\n  }\n}\n    "])));
/**
 * __useGetDocumentQuery__
 *
 * To run a query within a Vue component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDocumentQuery({
 *   docId: // value for 'docId'
 * });
 */
export function useGetDocumentQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetDocumentDocument, variables, options);
}
export function useGetDocumentLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetDocumentDocument, variables, options);
}
export var GetPageIdsDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    query GetPageIds($docId: ID!) {\n  document(docId: $docId) {\n    id\n    isPublished\n    updatedAt\n    pages {\n      id\n      hasUnpublishedChanges\n      order\n      updatedAt\n      title\n    }\n  }\n}\n    "], ["\n    query GetPageIds($docId: ID!) {\n  document(docId: $docId) {\n    id\n    isPublished\n    updatedAt\n    pages {\n      id\n      hasUnpublishedChanges\n      order\n      updatedAt\n      title\n    }\n  }\n}\n    "])));
/**
 * __useGetPageIdsQuery__
 *
 * To run a query within a Vue component, call `useGetPageIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPageIdsQuery({
 *   docId: // value for 'docId'
 * });
 */
export function useGetPageIdsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetPageIdsDocument, variables, options);
}
export function useGetPageIdsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetPageIdsDocument, variables, options);
}
export var CompleteDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    mutation Complete($params: CompleteFileInput!) {\n  complete(params: $params) {\n    id\n    mimeType\n    name\n    owner {\n      id\n    }\n    size\n    uploadedAt\n    url\n    video {\n      id\n      provider\n      videoId\n      videoShortId\n    }\n  }\n}\n    "], ["\n    mutation Complete($params: CompleteFileInput!) {\n  complete(params: $params) {\n    id\n    mimeType\n    name\n    owner {\n      id\n    }\n    size\n    uploadedAt\n    url\n    video {\n      id\n      provider\n      videoId\n      videoShortId\n    }\n  }\n}\n    "])));
/**
 * __useCompleteMutation__
 *
 * To run a mutation, you first call `useCompleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteMutation({
 *   variables: {
 *     params: // value for 'params'
 *   },
 * });
 */
export function useCompleteMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(CompleteDocument, options);
}
export var ReserveDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    mutation Reserve($params: ReserveFileInput!) {\n  reserve(params: $params) {\n    fileId\n    links {\n      partNumber\n      url\n    }\n  }\n}\n    "], ["\n    mutation Reserve($params: ReserveFileInput!) {\n  reserve(params: $params) {\n    fileId\n    links {\n      partNumber\n      url\n    }\n  }\n}\n    "])));
/**
 * __useReserveMutation__
 *
 * To run a mutation, you first call `useReserveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReserveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReserveMutation({
 *   variables: {
 *     params: // value for 'params'
 *   },
 * });
 */
export function useReserveMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(ReserveDocument, options);
}
export var SetAllReadedDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    mutation SetAllReaded {\n  readAll\n}\n    "], ["\n    mutation SetAllReaded {\n  readAll\n}\n    "])));
/**
 * __useSetAllReadedMutation__
 *
 * To run a mutation, you first call `useSetAllReadedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetAllReadedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetAllReadedMutation();
 */
export function useSetAllReadedMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(SetAllReadedDocument, options);
}
export var SetNotificationReadedDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    mutation SetNotificationReaded($id: ID!) {\n  markAsViewed(id: $id) {\n    success\n  }\n}\n    "], ["\n    mutation SetNotificationReaded($id: ID!) {\n  markAsViewed(id: $id) {\n    success\n  }\n}\n    "])));
/**
 * __useSetNotificationReadedMutation__
 *
 * To run a mutation, you first call `useSetNotificationReadedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationReadedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationReadedMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSetNotificationReadedMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(SetNotificationReadedDocument, options);
}
export var SetNotificationUnreadedDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    mutation SetNotificationUnreaded($id: ID!) {\n  markUnread(id: $id) {\n    success\n  }\n}\n    "], ["\n    mutation SetNotificationUnreaded($id: ID!) {\n  markUnread(id: $id) {\n    success\n  }\n}\n    "])));
/**
 * __useSetNotificationUnreadedMutation__
 *
 * To run a mutation, you first call `useSetNotificationUnreadedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationUnreadedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationUnreadedMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSetNotificationUnreadedMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(SetNotificationUnreadedDocument, options);
}
export var SetNotificationsSettingsDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    mutation SetNotificationsSettings($dto: SetSettingsInput!, $role: RoleEnum!) {\n  setNotificationsSettings(dto: $dto, role: $role) {\n    AFFILIATE_UPDATES\n    BILLING\n    CHAT\n    COURSES\n    COURSE_STUDENT_FINISHED\n    DEADLINES\n    GROUP_STUDENT_LIMIT_OVER\n    HOMEWORKS\n    SCHOOL_SETTINGS\n    WEBINARS\n    sound\n  }\n}\n    "], ["\n    mutation SetNotificationsSettings($dto: SetSettingsInput!, $role: RoleEnum!) {\n  setNotificationsSettings(dto: $dto, role: $role) {\n    AFFILIATE_UPDATES\n    BILLING\n    CHAT\n    COURSES\n    COURSE_STUDENT_FINISHED\n    DEADLINES\n    GROUP_STUDENT_LIMIT_OVER\n    HOMEWORKS\n    SCHOOL_SETTINGS\n    WEBINARS\n    sound\n  }\n}\n    "])));
/**
 * __useSetNotificationsSettingsMutation__
 *
 * To run a mutation, you first call `useSetNotificationsSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationsSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationsSettingsMutation({
 *   variables: {
 *     dto: // value for 'dto'
 *     role: // value for 'role'
 *   },
 * });
 */
export function useSetNotificationsSettingsMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(SetNotificationsSettingsDocument, options);
}
export var GetAllNotificationsDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    query GetAllNotifications($pagination: PaginationDto!) {\n  notifications(pagination: $pagination) {\n    id\n    text\n    createdAt\n    viewed\n    action\n    group\n    meta {\n      course {\n        id\n        uuid\n        avatar\n        name\n      }\n      lesson {\n        uuid\n        id\n        avatar\n        name\n      }\n      group {\n        id\n        uuid\n        avatar\n        name\n      }\n      student {\n        id\n        uuid\n        avatar\n        name\n      }\n      teacher {\n        id\n        uuid\n        avatar\n        name\n      }\n      webinar {\n        startAt\n      }\n      homeworkUser {\n        uuid\n      }\n      stream {\n        id\n        title\n      }\n    }\n  }\n  notificationsCount {\n    countAll\n    countUnread\n    group\n  }\n}\n    "], ["\n    query GetAllNotifications($pagination: PaginationDto!) {\n  notifications(pagination: $pagination) {\n    id\n    text\n    createdAt\n    viewed\n    action\n    group\n    meta {\n      course {\n        id\n        uuid\n        avatar\n        name\n      }\n      lesson {\n        uuid\n        id\n        avatar\n        name\n      }\n      group {\n        id\n        uuid\n        avatar\n        name\n      }\n      student {\n        id\n        uuid\n        avatar\n        name\n      }\n      teacher {\n        id\n        uuid\n        avatar\n        name\n      }\n      webinar {\n        startAt\n      }\n      homeworkUser {\n        uuid\n      }\n      stream {\n        id\n        title\n      }\n    }\n  }\n  notificationsCount {\n    countAll\n    countUnread\n    group\n  }\n}\n    "])));
/**
 * __useGetAllNotificationsQuery__
 *
 * To run a query within a Vue component, call `useGetAllNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllNotificationsQuery({
 *   pagination: // value for 'pagination'
 * });
 */
export function useGetAllNotificationsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetAllNotificationsDocument, variables, options);
}
export function useGetAllNotificationsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetAllNotificationsDocument, variables, options);
}
export var GetNotificationsMapDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    query GetNotificationsMap {\n  notificationsMap {\n    actions\n    clients\n    settings\n    labels\n  }\n}\n    "], ["\n    query GetNotificationsMap {\n  notificationsMap {\n    actions\n    clients\n    settings\n    labels\n  }\n}\n    "])));
/**
 * __useGetNotificationsMapQuery__
 *
 * To run a query within a Vue component, call `useGetNotificationsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsMapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNotificationsMapQuery();
 */
export function useGetNotificationsMapQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetNotificationsMapDocument, {}, options);
}
export function useGetNotificationsMapLazyQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetNotificationsMapDocument, {}, options);
}
export var GetNotificationsSettingsDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    query GetNotificationsSettings($role: RoleEnum!) {\n  notificationsSettings(role: $role) {\n    AFFILIATE_UPDATES\n    BILLING\n    CHAT\n    COURSES\n    COURSE_STUDENT_FINISHED\n    DEADLINES\n    GROUP_STUDENT_LIMIT_OVER\n    HOMEWORKS\n    SCHOOL_SETTINGS\n    WEBINARS\n    sound\n  }\n}\n    "], ["\n    query GetNotificationsSettings($role: RoleEnum!) {\n  notificationsSettings(role: $role) {\n    AFFILIATE_UPDATES\n    BILLING\n    CHAT\n    COURSES\n    COURSE_STUDENT_FINISHED\n    DEADLINES\n    GROUP_STUDENT_LIMIT_OVER\n    HOMEWORKS\n    SCHOOL_SETTINGS\n    WEBINARS\n    sound\n  }\n}\n    "])));
/**
 * __useGetNotificationsSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetNotificationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNotificationsSettingsQuery({
 *   role: // value for 'role'
 * });
 */
export function useGetNotificationsSettingsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetNotificationsSettingsDocument, variables, options);
}
export function useGetNotificationsSettingsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetNotificationsSettingsDocument, variables, options);
}
export var TestSmtpSettingsDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    mutation TestSmtpSettings {\n  testSmtpSettings {\n    success\n  }\n}\n    "], ["\n    mutation TestSmtpSettings {\n  testSmtpSettings {\n    success\n  }\n}\n    "])));
/**
 * __useTestSmtpSettingsMutation__
 *
 * To run a mutation, you first call `useTestSmtpSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestSmtpSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestSmtpSettingsMutation();
 */
export function useTestSmtpSettingsMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(TestSmtpSettingsDocument, options);
}
export var UpdateSmtpSettingsDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    mutation UpdateSmtpSettings($params: UpdateSmtpSettingsInput!) {\n  updateSmtpSettings(params: $params) {\n    email\n    host\n    password\n    port\n    useCustomSmtp\n    user\n  }\n}\n    "], ["\n    mutation UpdateSmtpSettings($params: UpdateSmtpSettingsInput!) {\n  updateSmtpSettings(params: $params) {\n    email\n    host\n    password\n    port\n    useCustomSmtp\n    user\n  }\n}\n    "])));
/**
 * __useUpdateSmtpSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSmtpSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmtpSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSmtpSettingsMutation({
 *   variables: {
 *     params: // value for 'params'
 *   },
 * });
 */
export function useUpdateSmtpSettingsMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdateSmtpSettingsDocument, options);
}
export var GetSmtpSettingsDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    query GetSmtpSettings {\n  smtpSettings {\n    email\n    host\n    password\n    port\n    useCustomSmtp\n    user\n  }\n}\n    "], ["\n    query GetSmtpSettings {\n  smtpSettings {\n    email\n    host\n    password\n    port\n    useCustomSmtp\n    user\n  }\n}\n    "])));
/**
 * __useGetSmtpSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetSmtpSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmtpSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSmtpSettingsQuery();
 */
export function useGetSmtpSettingsQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetSmtpSettingsDocument, {}, options);
}
export function useGetSmtpSettingsLazyQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetSmtpSettingsDocument, {}, options);
}
export var CreateStudentNoteDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    mutation createStudentNote($attachmentIds: [String!]!, $studentId: String!, $text: String!) {\n  createStudentNote(\n    attachmentIds: $attachmentIds\n    studentId: $studentId\n    text: $text\n  ) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "], ["\n    mutation createStudentNote($attachmentIds: [String!]!, $studentId: String!, $text: String!) {\n  createStudentNote(\n    attachmentIds: $attachmentIds\n    studentId: $studentId\n    text: $text\n  ) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "])));
/**
 * __useCreateStudentNoteMutation__
 *
 * To run a mutation, you first call `useCreateStudentNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStudentNoteMutation({
 *   variables: {
 *     attachmentIds: // value for 'attachmentIds'
 *     studentId: // value for 'studentId'
 *     text: // value for 'text'
 *   },
 * });
 */
export function useCreateStudentNoteMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(CreateStudentNoteDocument, options);
}
export var DeleteStudentNotesDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    mutation deleteStudentNotes($ids: [String!]!) {\n  deleteStudentNotes(ids: $ids)\n}\n    "], ["\n    mutation deleteStudentNotes($ids: [String!]!) {\n  deleteStudentNotes(ids: $ids)\n}\n    "])));
/**
 * __useDeleteStudentNotesMutation__
 *
 * To run a mutation, you first call `useDeleteStudentNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStudentNotesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteStudentNotesMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(DeleteStudentNotesDocument, options);
}
export var UpdateStudentNoteDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    mutation updateStudentNote($attachmentIds: [String!]!, $id: String!, $text: String!) {\n  updateStudentNote(attachmentIds: $attachmentIds, id: $id, text: $text) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "], ["\n    mutation updateStudentNote($attachmentIds: [String!]!, $id: String!, $text: String!) {\n  updateStudentNote(attachmentIds: $attachmentIds, id: $id, text: $text) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "])));
/**
 * __useUpdateStudentNoteMutation__
 *
 * To run a mutation, you first call `useUpdateStudentNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentNoteMutation({
 *   variables: {
 *     attachmentIds: // value for 'attachmentIds'
 *     id: // value for 'id'
 *     text: // value for 'text'
 *   },
 * });
 */
export function useUpdateStudentNoteMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdateStudentNoteDocument, options);
}
export var GetStudentNotesDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    query GetStudentNotes($studentId: String!) {\n  studentNotesList(studentId: $studentId) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "], ["\n    query GetStudentNotes($studentId: String!) {\n  studentNotesList(studentId: $studentId) {\n    attachments {\n      id\n      url\n      mimeType\n      size\n      name\n    }\n    createdBy\n    createdAt\n    updatedAt\n    schoolId\n    studentId\n    text\n    id\n  }\n}\n    "])));
/**
 * __useGetStudentNotesQuery__
 *
 * To run a query within a Vue component, call `useGetStudentNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentNotesQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGetStudentNotesQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetStudentNotesDocument, variables, options);
}
export function useGetStudentNotesLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetStudentNotesDocument, variables, options);
}
export var GetWebinarColumnsDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    query GetWebinarColumns {\n  webinarColumns {\n    title\n    value\n    hint\n    readonly\n    sortable\n    sortField\n  }\n}\n    "], ["\n    query GetWebinarColumns {\n  webinarColumns {\n    title\n    value\n    hint\n    readonly\n    sortable\n    sortField\n  }\n}\n    "])));
/**
 * __useGetWebinarColumnsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarColumnsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarColumnsQuery();
 */
export function useGetWebinarColumnsQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarColumnsDocument, {}, options);
}
export function useGetWebinarColumnsLazyQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarColumnsDocument, {}, options);
}
export var GetWebinarFiltersDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    query GetWebinarFilters {\n  webinarFilters {\n    name\n    title\n    value\n    valueGroup\n    type\n  }\n}\n    "], ["\n    query GetWebinarFilters {\n  webinarFilters {\n    name\n    title\n    value\n    valueGroup\n    type\n  }\n}\n    "])));
/**
 * __useGetWebinarFiltersQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarFiltersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarFiltersQuery();
 */
export function useGetWebinarFiltersQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarFiltersDocument, {}, options);
}
export function useGetWebinarFiltersLazyQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarFiltersDocument, {}, options);
}
export var GetWebinarStatisticsDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    query GetWebinarStatistics($search: String, $sort: WebinarsSortArgs, $pagination: PaginationArgs, $filters: WebinarsFiltersArgs) {\n  webinarStatistics(\n    search: $search\n    sort: $sort\n    pagination: $pagination\n    filters: $filters\n  ) {\n    count\n    data {\n      name\n      customFields {\n        customFieldId\n        value\n      }\n      email\n      id\n      streams {\n        streamId\n        studentId\n        completed\n        visitingStatus\n        stream {\n          id\n          name\n          webinarId\n        }\n      }\n      webinars {\n        id\n        name\n      }\n      phone\n    }\n    page\n    size\n    pages\n  }\n}\n    "], ["\n    query GetWebinarStatistics($search: String, $sort: WebinarsSortArgs, $pagination: PaginationArgs, $filters: WebinarsFiltersArgs) {\n  webinarStatistics(\n    search: $search\n    sort: $sort\n    pagination: $pagination\n    filters: $filters\n  ) {\n    count\n    data {\n      name\n      customFields {\n        customFieldId\n        value\n      }\n      email\n      id\n      streams {\n        streamId\n        studentId\n        completed\n        visitingStatus\n        stream {\n          id\n          name\n          webinarId\n        }\n      }\n      webinars {\n        id\n        name\n      }\n      phone\n    }\n    page\n    size\n    pages\n  }\n}\n    "])));
/**
 * __useGetWebinarStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarStatisticsQuery({
 *   search: // value for 'search'
 *   sort: // value for 'sort'
 *   pagination: // value for 'pagination'
 *   filters: // value for 'filters'
 * });
 */
export function useGetWebinarStatisticsQuery(variables, options) {
    if (variables === void 0) { variables = {}; }
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarStatisticsDocument, variables, options);
}
export function useGetWebinarStatisticsLazyQuery(variables, options) {
    if (variables === void 0) { variables = {}; }
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarStatisticsDocument, variables, options);
}
export var CheckRegistrationDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    mutation CheckRegistration($streamId: ID!, $userEmail: String!) {\n  checkRegistration(streamId: $streamId, userEmail: $userEmail) {\n    email\n    name\n    timezone\n    phoneNumber\n    uuid\n    hasOnStream\n  }\n}\n    "], ["\n    mutation CheckRegistration($streamId: ID!, $userEmail: String!) {\n  checkRegistration(streamId: $streamId, userEmail: $userEmail) {\n    email\n    name\n    timezone\n    phoneNumber\n    uuid\n    hasOnStream\n  }\n}\n    "])));
/**
 * __useCheckRegistrationMutation__
 *
 * To run a mutation, you first call `useCheckRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckRegistrationMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useCheckRegistrationMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(CheckRegistrationDocument, options);
}
export var CreateStreamDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    mutation CreateStream($input: StreamCreateInput!, $webinarId: ID!) {\n  createStream(createStreamInput: $input, webinarId: $webinarId) {\n    id\n    title\n    date\n    duration\n  }\n}\n    "], ["\n    mutation CreateStream($input: StreamCreateInput!, $webinarId: ID!) {\n  createStream(createStreamInput: $input, webinarId: $webinarId) {\n    id\n    title\n    date\n    duration\n  }\n}\n    "])));
/**
 * __useCreateStreamMutation__
 *
 * To run a mutation, you first call `useCreateStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStreamMutation({
 *   variables: {
 *     input: // value for 'input'
 *     webinarId: // value for 'webinarId'
 *   },
 * });
 */
export function useCreateStreamMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(CreateStreamDocument, options);
}
export var CreateWebinarDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    mutation CreateWebinar($input: WebinarExternalCreateInput!) {\n  createWebinar(createWebinarExternalInput: $input) {\n    id\n    title\n    description\n    streams {\n      id\n      title\n      date\n    }\n  }\n}\n    "], ["\n    mutation CreateWebinar($input: WebinarExternalCreateInput!) {\n  createWebinar(createWebinarExternalInput: $input) {\n    id\n    title\n    description\n    streams {\n      id\n      title\n      date\n    }\n  }\n}\n    "])));
/**
 * __useCreateWebinarMutation__
 *
 * To run a mutation, you first call `useCreateWebinarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebinarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWebinarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebinarMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(CreateWebinarDocument, options);
}
export var DeleteStreamDocument = gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    mutation DeleteStream($streamId: ID!) {\n  deleteStream(streamId: $streamId) {\n    success\n  }\n}\n    "], ["\n    mutation DeleteStream($streamId: ID!) {\n  deleteStream(streamId: $streamId) {\n    success\n  }\n}\n    "])));
/**
 * __useDeleteStreamMutation__
 *
 * To run a mutation, you first call `useDeleteStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStreamMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useDeleteStreamMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(DeleteStreamDocument, options);
}
export var DeleteWebinarDocument = gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    mutation DeleteWebinar($webinarId: ID!) {\n  deleteWebinar(webinarId: $webinarId) {\n    success\n  }\n}\n    "], ["\n    mutation DeleteWebinar($webinarId: ID!) {\n  deleteWebinar(webinarId: $webinarId) {\n    success\n  }\n}\n    "])));
/**
 * __useDeleteWebinarMutation__
 *
 * To run a mutation, you first call `useDeleteWebinarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebinarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWebinarMutation({
 *   variables: {
 *     webinarId: // value for 'webinarId'
 *   },
 * });
 */
export function useDeleteWebinarMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(DeleteWebinarDocument, options);
}
export var InviteStudentsDocument = gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n    mutation InviteStudents($emails: [String!]!, $streamIds: [ID!]!) {\n  inviteStudents(emails: $emails, streamIds: $streamIds) {\n    perStream {\n      invitedCount\n      streamId\n    }\n    perWebinar {\n      invitedCount\n      webinarId\n    }\n  }\n}\n    "], ["\n    mutation InviteStudents($emails: [String!]!, $streamIds: [ID!]!) {\n  inviteStudents(emails: $emails, streamIds: $streamIds) {\n    perStream {\n      invitedCount\n      streamId\n    }\n    perWebinar {\n      invitedCount\n      webinarId\n    }\n  }\n}\n    "])));
/**
 * __useInviteStudentsMutation__
 *
 * To run a mutation, you first call `useInviteStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteStudentsMutation({
 *   variables: {
 *     emails: // value for 'emails'
 *     streamIds: // value for 'streamIds'
 *   },
 * });
 */
export function useInviteStudentsMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(InviteStudentsDocument, options);
}
export var JoinWebinarDocument = gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    mutation JoinWebinar($streamId: ID!, $email: String!, $name: String) {\n  joinWebinar(streamId: $streamId, email: $email, name: $name) {\n    externalStreamUrl\n    recordUrl\n    savedRecordFileId\n    savedRecord {\n      video {\n        videoShortId\n      }\n    }\n    savedRecordUrl\n    uploadedRecord {\n      name\n      video {\n        videoShortId\n      }\n    }\n    uploadedRecordFileId\n    displayRecordType\n  }\n}\n    "], ["\n    mutation JoinWebinar($streamId: ID!, $email: String!, $name: String) {\n  joinWebinar(streamId: $streamId, email: $email, name: $name) {\n    externalStreamUrl\n    recordUrl\n    savedRecordFileId\n    savedRecord {\n      video {\n        videoShortId\n      }\n    }\n    savedRecordUrl\n    uploadedRecord {\n      name\n      video {\n        videoShortId\n      }\n    }\n    uploadedRecordFileId\n    displayRecordType\n  }\n}\n    "])));
/**
 * __useJoinWebinarMutation__
 *
 * To run a mutation, you first call `useJoinWebinarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useJoinWebinarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useJoinWebinarMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     email: // value for 'email'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useJoinWebinarMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(JoinWebinarDocument, options);
}
export var RateStreamDocument = gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n    mutation RateStream($streamId: ID!, $action: StreamRateAction!, $userId: ID!) {\n  rateStream(streamId: $streamId, action: $action, userId: $userId) {\n    dislikesCount\n    likesCount\n    userRating\n  }\n}\n    "], ["\n    mutation RateStream($streamId: ID!, $action: StreamRateAction!, $userId: ID!) {\n  rateStream(streamId: $streamId, action: $action, userId: $userId) {\n    dislikesCount\n    likesCount\n    userRating\n  }\n}\n    "])));
/**
 * __useRateStreamMutation__
 *
 * To run a mutation, you first call `useRateStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRateStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRateStreamMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     action: // value for 'action'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useRateStreamMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(RateStreamDocument, options);
}
export var RegisterStudentDocument = gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    mutation RegisterStudent($streamId: ID!, $email: String!, $name: String!, $timezone: String!, $phoneNumber: String, $token: String) {\n  registerStudent(\n    email: $email\n    streamId: $streamId\n    name: $name\n    phoneNumber: $phoneNumber\n    timezone: $timezone\n    token: $token\n  ) {\n    email\n    uuid\n  }\n}\n    "], ["\n    mutation RegisterStudent($streamId: ID!, $email: String!, $name: String!, $timezone: String!, $phoneNumber: String, $token: String) {\n  registerStudent(\n    email: $email\n    streamId: $streamId\n    name: $name\n    phoneNumber: $phoneNumber\n    timezone: $timezone\n    token: $token\n  ) {\n    email\n    uuid\n  }\n}\n    "])));
/**
 * __useRegisterStudentMutation__
 *
 * To run a mutation, you first call `useRegisterStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterStudentMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     email: // value for 'email'
 *     name: // value for 'name'
 *     timezone: // value for 'timezone'
 *     phoneNumber: // value for 'phoneNumber'
 *     token: // value for 'token'
 *   },
 * });
 */
export function useRegisterStudentMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(RegisterStudentDocument, options);
}
export var ShareStreamDocument = gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n    mutation ShareStream($streamId: ID!, $userId: ID!) {\n  shareStream(streamId: $streamId, userId: $userId) {\n    sharesCount\n    success\n  }\n}\n    "], ["\n    mutation ShareStream($streamId: ID!, $userId: ID!) {\n  shareStream(streamId: $streamId, userId: $userId) {\n    sharesCount\n    success\n  }\n}\n    "])));
/**
 * __useShareStreamMutation__
 *
 * To run a mutation, you first call `useShareStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShareStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShareStreamMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useShareStreamMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(ShareStreamDocument, options);
}
export var UpdateStreamDocument = gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n    mutation UpdateStream($streamId: ID!, $input: StreamUpdateInput!) {\n  updateStream(streamId: $streamId, updateStreamInput: $input) {\n    title\n    id\n    date\n    duration\n    coverFileId\n    cover {\n      url\n    }\n    hasRecord\n    recordUrl\n    autoRecord\n    savedRecordFileId\n    savedRecordUrl\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n    }\n    hasRecordUrl\n    streamType\n    externalStreamUrl\n    countRegistered\n    countViewed\n    isRegistered\n    isSpeaker\n    speakers\n    webinarId\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    registrationType\n    isShowShareButton\n  }\n}\n    "], ["\n    mutation UpdateStream($streamId: ID!, $input: StreamUpdateInput!) {\n  updateStream(streamId: $streamId, updateStreamInput: $input) {\n    title\n    id\n    date\n    duration\n    coverFileId\n    cover {\n      url\n    }\n    hasRecord\n    recordUrl\n    autoRecord\n    savedRecordFileId\n    savedRecordUrl\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n    }\n    hasRecordUrl\n    streamType\n    externalStreamUrl\n    countRegistered\n    countViewed\n    isRegistered\n    isSpeaker\n    speakers\n    webinarId\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    registrationType\n    isShowShareButton\n  }\n}\n    "])));
/**
 * __useUpdateStreamMutation__
 *
 * To run a mutation, you first call `useUpdateStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStreamMutation({
 *   variables: {
 *     streamId: // value for 'streamId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStreamMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdateStreamDocument, options);
}
export var UpdateWebinarDocument = gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n    mutation UpdateWebinar($webinarId: ID!, $input: WebinarExternalUpdateInput!) {\n  updateWebinar(webinarId: $webinarId, updateWebinarExternalInput: $input) {\n    title\n    id\n    description\n    coverFileId\n    cover {\n      url\n    }\n    countRegistered\n    countViewed\n    externalLandingUrl\n    integrationCode\n    maxStudentCapacity\n    registrationType\n    registrationForEntry\n    registrationForView\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n    useDefaultLanding\n    visibility\n  }\n}\n    "], ["\n    mutation UpdateWebinar($webinarId: ID!, $input: WebinarExternalUpdateInput!) {\n  updateWebinar(webinarId: $webinarId, updateWebinarExternalInput: $input) {\n    title\n    id\n    description\n    coverFileId\n    cover {\n      url\n    }\n    countRegistered\n    countViewed\n    externalLandingUrl\n    integrationCode\n    maxStudentCapacity\n    registrationType\n    registrationForEntry\n    registrationForView\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n    useDefaultLanding\n    visibility\n  }\n}\n    "])));
/**
 * __useUpdateWebinarMutation__
 *
 * To run a mutation, you first call `useUpdateWebinarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebinarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWebinarMutation({
 *   variables: {
 *     webinarId: // value for 'webinarId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebinarMutation(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useMutation(UpdateWebinarDocument, options);
}
export var GetStreamDocument = gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n    query GetStream($streamId: ID!) {\n  stream(streamId: $streamId) {\n    title\n    id\n    date\n    duration\n    coverFileId\n    cover {\n      url\n    }\n    recordUrl\n    streamType\n    externalStreamUrl\n    hasRecordUrl\n    hasRecord\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n    }\n    countRegistered\n    countViewed\n    isRegistered\n    isSpeaker\n    canModify\n    canRemove\n    webinarId\n    webinarDescription\n    webinarTitle\n    integrationCode\n    registrationType\n    autoRecord\n    savedRecordFileId\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    isShowShareButton\n    docId\n  }\n}\n    "], ["\n    query GetStream($streamId: ID!) {\n  stream(streamId: $streamId) {\n    title\n    id\n    date\n    duration\n    coverFileId\n    cover {\n      url\n    }\n    recordUrl\n    streamType\n    externalStreamUrl\n    hasRecordUrl\n    hasRecord\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n    }\n    countRegistered\n    countViewed\n    isRegistered\n    isSpeaker\n    canModify\n    canRemove\n    webinarId\n    webinarDescription\n    webinarTitle\n    integrationCode\n    registrationType\n    autoRecord\n    savedRecordFileId\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    isShowShareButton\n    docId\n  }\n}\n    "])));
/**
 * __useGetStreamQuery__
 *
 * To run a query within a Vue component, call `useGetStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStreamQuery({
 *   streamId: // value for 'streamId'
 * });
 */
export function useGetStreamQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetStreamDocument, variables, options);
}
export function useGetStreamLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetStreamDocument, variables, options);
}
export var GetStreamSettingsDocument = gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n    query GetStreamSettings($streamId: ID!) {\n  stream(streamId: $streamId) {\n    coverFileId\n    cover {\n      url\n    }\n    date\n    duration\n    externalStreamUrl\n    hasRecordUrl\n    hasRecord\n    id\n    recordUrl\n    speakers\n    streamType\n    title\n    webinarId\n    canModify\n    canRemove\n    autoRecord\n    savedRecordFileId\n    savedRecord {\n      url\n      name\n      video {\n        id\n        provider\n        videoId\n        videoShortId\n      }\n    }\n    savedRecordUrl\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n      video {\n        id\n        provider\n        videoId\n        videoShortId\n      }\n    }\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    registrationType\n  }\n}\n    "], ["\n    query GetStreamSettings($streamId: ID!) {\n  stream(streamId: $streamId) {\n    coverFileId\n    cover {\n      url\n    }\n    date\n    duration\n    externalStreamUrl\n    hasRecordUrl\n    hasRecord\n    id\n    recordUrl\n    speakers\n    streamType\n    title\n    webinarId\n    canModify\n    canRemove\n    autoRecord\n    savedRecordFileId\n    savedRecord {\n      url\n      name\n      video {\n        id\n        provider\n        videoId\n        videoShortId\n      }\n    }\n    savedRecordUrl\n    uploadedRecordFileId\n    uploadedRecord {\n      url\n      name\n      video {\n        id\n        provider\n        videoId\n        videoShortId\n      }\n    }\n    isAllowedToJoin\n    isLive\n    useNotifications\n    displayRecordType\n    registrationType\n  }\n}\n    "])));
/**
 * __useGetStreamSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetStreamSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStreamSettingsQuery({
 *   streamId: // value for 'streamId'
 * });
 */
export function useGetStreamSettingsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetStreamSettingsDocument, variables, options);
}
export function useGetStreamSettingsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetStreamSettingsDocument, variables, options);
}
export var GetStreamSocialActivityDocument = gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n    query GetStreamSocialActivity($streamId: ID!) {\n  streamSocialActivity(streamId: $streamId) {\n    dislikesCount\n    hasShared\n    likesCount\n    sharesCount\n    userRating\n  }\n}\n    "], ["\n    query GetStreamSocialActivity($streamId: ID!) {\n  streamSocialActivity(streamId: $streamId) {\n    dislikesCount\n    hasShared\n    likesCount\n    sharesCount\n    userRating\n  }\n}\n    "])));
/**
 * __useGetStreamSocialActivityQuery__
 *
 * To run a query within a Vue component, call `useGetStreamSocialActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamSocialActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStreamSocialActivityQuery({
 *   streamId: // value for 'streamId'
 * });
 */
export function useGetStreamSocialActivityQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetStreamSocialActivityDocument, variables, options);
}
export function useGetStreamSocialActivityLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetStreamSocialActivityDocument, variables, options);
}
export var GetStudentWebinarsDocument = gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n    query getStudentWebinars($studentId: String!) {\n  studentWebinarCards(studentId: $studentId) {\n    data {\n      webinarId\n      cover {\n        url\n        id\n      }\n      title\n      hasFinished\n      date\n      userStatus\n      streamTitle\n    }\n    total\n  }\n}\n    "], ["\n    query getStudentWebinars($studentId: String!) {\n  studentWebinarCards(studentId: $studentId) {\n    data {\n      webinarId\n      cover {\n        url\n        id\n      }\n      title\n      hasFinished\n      date\n      userStatus\n      streamTitle\n    }\n    total\n  }\n}\n    "])));
/**
 * __useGetStudentWebinarsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentWebinarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentWebinarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentWebinarsQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGetStudentWebinarsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetStudentWebinarsDocument, variables, options);
}
export function useGetStudentWebinarsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetStudentWebinarsDocument, variables, options);
}
export var GetWebinarCardsDocument = gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    query GetWebinarCards($filter: WebinarCardsFilter!) {\n  webinarCards(filter: $filter) {\n    data {\n      date\n      description\n      duration\n      isRegistered\n      isSpeaker\n      isViewed\n      streamId\n      title\n      webinarId\n      visibility\n      hasRecord\n      isAllowedToJoin\n      isLive\n      cover {\n        url\n      }\n      coverFileId\n    }\n    total\n  }\n}\n    "], ["\n    query GetWebinarCards($filter: WebinarCardsFilter!) {\n  webinarCards(filter: $filter) {\n    data {\n      date\n      description\n      duration\n      isRegistered\n      isSpeaker\n      isViewed\n      streamId\n      title\n      webinarId\n      visibility\n      hasRecord\n      isAllowedToJoin\n      isLive\n      cover {\n        url\n      }\n      coverFileId\n    }\n    total\n  }\n}\n    "])));
/**
 * __useGetWebinarCardsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarCardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarCardsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useGetWebinarCardsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarCardsDocument, variables, options);
}
export function useGetWebinarCardsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarCardsDocument, variables, options);
}
export var GetWebinarMainInfoDocument = gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    query GetWebinarMainInfo($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    visibility\n    countRegistered\n    countViewed\n    canModify\n    canRemove\n    streams {\n      id\n      title\n      date\n      duration\n      canModify\n      canRemove\n      countRegistered\n    }\n  }\n}\n    "], ["\n    query GetWebinarMainInfo($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    visibility\n    countRegistered\n    countViewed\n    canModify\n    canRemove\n    streams {\n      id\n      title\n      date\n      duration\n      canModify\n      canRemove\n      countRegistered\n    }\n  }\n}\n    "])));
/**
 * __useGetWebinarMainInfoQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarMainInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarMainInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarMainInfoQuery({
 *   webinarId: // value for 'webinarId'
 * });
 */
export function useGetWebinarMainInfoQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarMainInfoDocument, variables, options);
}
export function useGetWebinarMainInfoLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarMainInfoDocument, variables, options);
}
export var GetWebinarSettingsDocument = gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n    query GetWebinarSettings($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    createdBy\n    registrationType\n    registrationForEntry\n    registrationForView\n    maxStudentCapacity\n    useAttendancePoints\n    attendancePoints\n    enableStudentLimit\n    useDefaultLanding\n    externalLandingUrl\n    visibility\n    integrationCode\n    canModify\n    canRemove\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n  }\n}\n    "], ["\n    query GetWebinarSettings($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    createdBy\n    registrationType\n    registrationForEntry\n    registrationForView\n    maxStudentCapacity\n    useAttendancePoints\n    attendancePoints\n    enableStudentLimit\n    useDefaultLanding\n    externalLandingUrl\n    visibility\n    integrationCode\n    canModify\n    canRemove\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n  }\n}\n    "])));
/**
 * __useGetWebinarSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarSettingsQuery({
 *   webinarId: // value for 'webinarId'
 * });
 */
export function useGetWebinarSettingsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarSettingsDocument, variables, options);
}
export function useGetWebinarSettingsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarSettingsDocument, variables, options);
}
export var GetWebinarSocialActivityDocument = gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    query GetWebinarSocialActivity($webinarId: ID!) {\n  webinarSocialActivity(webinarId: $webinarId) {\n    dislikesCount\n    hasShared\n    likesCount\n    sharesCount\n    userRating\n  }\n}\n    "], ["\n    query GetWebinarSocialActivity($webinarId: ID!) {\n  webinarSocialActivity(webinarId: $webinarId) {\n    dislikesCount\n    hasShared\n    likesCount\n    sharesCount\n    userRating\n  }\n}\n    "])));
/**
 * __useGetWebinarSocialActivityQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarSocialActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarSocialActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarSocialActivityQuery({
 *   webinarId: // value for 'webinarId'
 * });
 */
export function useGetWebinarSocialActivityQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarSocialActivityDocument, variables, options);
}
export function useGetWebinarSocialActivityLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarSocialActivityDocument, variables, options);
}
export var GetWebinarStreamsDocument = gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n    query GetWebinarStreams($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    streams {\n      id\n      title\n      date\n      duration\n      canModify\n      canRemove\n      countRegistered\n    }\n    canModify\n  }\n}\n    "], ["\n    query GetWebinarStreams($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    streams {\n      id\n      title\n      date\n      duration\n      canModify\n      canRemove\n      countRegistered\n    }\n    canModify\n  }\n}\n    "])));
/**
 * __useGetWebinarStreamsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarStreamsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarStreamsQuery({
 *   webinarId: // value for 'webinarId'
 * });
 */
export function useGetWebinarStreamsQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarStreamsDocument, variables, options);
}
export function useGetWebinarStreamsLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarStreamsDocument, variables, options);
}
export var GetWebinarTranslationInfoDocument = gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n    query GetWebinarTranslationInfo($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    registrationType\n    registrationForEntry\n    registrationForView\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n  }\n}\n    "], ["\n    query GetWebinarTranslationInfo($webinarId: ID!) {\n  webinar(webinarId: $webinarId) {\n    id\n    title\n    description\n    coverFileId\n    cover {\n      url\n    }\n    registrationType\n    registrationForEntry\n    registrationForView\n    isPhoneRequiredOnRegistration\n    isShowShareButton\n  }\n}\n    "])));
/**
 * __useGetWebinarTranslationInfoQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarTranslationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarTranslationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarTranslationInfoQuery({
 *   webinarId: // value for 'webinarId'
 * });
 */
export function useGetWebinarTranslationInfoQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarTranslationInfoDocument, variables, options);
}
export function useGetWebinarTranslationInfoLazyQuery(variables, options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarTranslationInfoDocument, variables, options);
}
export var GetWebinarsDocument = gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n    query GetWebinars {\n  webinars {\n    countRegistered\n    coverFileId\n    cover {\n      url\n    }\n    id\n    streams {\n      countRegistered\n      date\n      duration\n      id\n      title\n      webinarId\n    }\n    title\n  }\n}\n    "], ["\n    query GetWebinars {\n  webinars {\n    countRegistered\n    coverFileId\n    cover {\n      url\n    }\n    id\n    streams {\n      countRegistered\n      date\n      duration\n      id\n      title\n      webinarId\n    }\n    title\n  }\n}\n    "])));
/**
 * __useGetWebinarsQuery__
 *
 * To run a query within a Vue component, call `useGetWebinarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWebinarsQuery();
 */
export function useGetWebinarsQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useQuery(GetWebinarsDocument, {}, options);
}
export function useGetWebinarsLazyQuery(options) {
    if (options === void 0) { options = {}; }
    return VueApolloComposable.useLazyQuery(GetWebinarsDocument, {}, options);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61;
